//
//
//


export default {

	functional: true,

	props:
	{
		tag:
		{
			type: String,
			default: 'div'
		}
	},

	render(createElement, { props, data, children, slots })
	{
		return createElement(
			props.tag,
			data,
			children
			// slots.default
		)
	},


}
